<agr-powerbi-report [workspaceId]="workspaceId" [reportId]="reportId"></agr-powerbi-report>
